import {Injectable} from '@angular/core';
import {AmplifyService} from 'aws-amplify-angular';
import {LanguageService} from './language.service';

const costumData = require('../data/litters.json');

@Injectable()
export class LitterService {
  private litters: LitterItem[] = [];
  private amplifyService: AmplifyService;
  private loaded: boolean;

  constructor(languageService: LanguageService, amplifyService: AmplifyService) {
    this.amplifyService = amplifyService;
    this.litters = this.loadLitters();
  }

  // @ts-ignore
  private loadLitters(): Array<LitterItem> {
    console.log(costumData);
    this.loaded = false;
    console.log('loading litters ...');
    const result = costumData.litters;
    console.log('... finished loading litters');
    this.loaded = true;
    return result;
  }

  public getLitters(): LitterItem[] {
    return this.litters;
  }

  public isLoaded(): boolean {
    return this.loaded;
  }
}


export class LitterItem {
  sire: String;
  dame: String;
  expected_at: String;

}
